namespace SPA
{
	export namespace gui
	{
		export namespace form
		{
			export function SimpleStyledPostalAddress(
				_form: ui.Form.Form,
				target: ui.base.BaseHTMLElement|JQuery,
				parameterBase: string,
				values: {[name: string]: string} = {},
				agsDisplay: "show" | "hidden" | "none" = "show",
				disabled: boolean = false
			): ui.Form.BasicInputField[]
			{
				const list = new Array();

				const parameterSuffix =  disabled ? '_display'  : '';

				if ( target instanceof ui.base.BaseHTMLElement )
				{
					target = target.Root();
				}

				if ( parameterBase.length > 0 && !parameterBase.endsWith( '.' ) )
				{
					parameterBase += '.';
				}

				let fg = ui.$$.div().addClass( 'form-group clearfix' ).appendTo( target );

				const add = ( input: ui.Form.BasicInputField, size: string[] ): void =>
				{
					input.addClass( size.join( ' ' ) );

					_form.Input( input );

					list.push( input );
				};

				const streetInput = new ui.Form.TextInput(
					values.street || values[parameterBase + 'street'] || '',
					{
						name: parameterBase + 'street' + parameterSuffix,
						disabled,
						required: true,
						placeholder: app.getMessage('Straße')
					}
				);
				streetInput.Initialize();
				add(streetInput, []);

				const streetHidden = new ui.Form.HiddenTextInput(values.street || values[parameterBase + 'street'] || '', parameterBase + 'street');
				streetHidden.Initialize();

				const housenumberInput = new ui.Form.TextInput(
					values.housenumber || values[parameterBase + 'housenumber'] || '',
					{
						name: parameterBase + 'housenumber' + parameterSuffix,
						disabled,
						required: true,
						maxlength: 5,
						placeholder: app.getMessage('Hausnummer')
					}
				);
				housenumberInput.Initialize();
				add(housenumberInput, []);

				const housenumberHidden = new ui.Form.HiddenTextInput(values.housenumber || values[parameterBase + 'housenumber'] || '', parameterBase + 'housenumber');
				housenumberHidden.Initialize();

				const postalcodeInput = new ui.Form.TextInput(
					values.postalcode || values[parameterBase + 'postalcode'] || '',
					{
						name: parameterBase + 'postalcode' + parameterSuffix,
						disabled,
						required: true,
						maxlength: 5,
						placeholder: app.getMessage('Address.LABEL.SHORT.Postalcode'),
						pattern: '(\\d){5}'
					}
				);
				postalcodeInput.Initialize();
				add(postalcodeInput, []);

				const postalHidden = new ui.Form.HiddenTextInput(values.postalcode || values[parameterBase + 'postalcode'] || '', parameterBase + 'postalcode');
				postalHidden.Initialize();

				const cityInput = new ui.Form.TextInput(
					values.city || values[parameterBase + 'city'] || '',
					{
						name: parameterBase + 'city' + parameterSuffix,
						disabled,
						required: true
					}
				);
				cityInput.Initialize();
				add(cityInput, []);

				const cityHidden = new ui.Form.HiddenTextInput(values.city || values[parameterBase + 'city'] || '', parameterBase + 'city');
				cityHidden.Initialize();

				const stateSelect = new ui.Form.Select(
					{
						blank: ' -- autom. ausgewählt -- ',
						name: parameterBase + 'state_display',
						disabled: true,
						required: true,
						control: true,
						option: SPA.types.Convert.ToObjectList(SPA.types.Address.State),
					}, values.state || values[parameterBase + 'state'] || ''
				);
				stateSelect.Initialize();
				add(stateSelect, []);

				const stateHidden = new ui.Form.HiddenTextInput(values.state || values[parameterBase + 'state'] || '', parameterBase + 'state');
				stateHidden.Initialize();
				add(stateHidden, []);

				const countryHidden = new ui.Form.HiddenTextInput('DE', parameterBase + 'country');
				countryHidden.Initialize();
				add(countryHidden, []);

				const agsInput = new ui.Form.TextInput(
					values.ags || values[parameterBase + 'ags'] || '',
					{
						placeholder: 'AGS',
						name: parameterBase + 'ags',
						control: true,
						disabled: agsDisplay === "show",
						attr: {
							type: agsDisplay === 'hidden' ? 'text' : 'text',
							class: 'shopags'
						},
						required: true
					}
				);

				agsInput.Initialize();
				add(agsInput, []);

				ui.$$.div().addClass('col-xs-12 col-sm-8')
					.append(ui.$$.label().text('Straße *'))
					.append(streetInput.Input())
					.appendTo(fg);
				ui.$$.div().addClass('col-xs-12 col-sm-4 nobreak')
					.append(ui.$$.label().text('Hausnummer *'))
					.append(housenumberInput.Input())
					.appendTo(fg);

				fg = ui.$$.div().addClass( 'form-group clearfix ui-front' ).appendTo( target );

				ui.$$.div().addClass(agsDisplay === 'show' ? 'col-xs-12' : 'col-xs-12 col-sm-4 col-md-3 nobreak')
					.append(ui.$$.label().text('Postleitzahl *'))
					.append(postalcodeInput.Input())
					.appendTo(fg);

				ui.$$.div().addClass(agsDisplay === 'show' ? 'col-xs-12' : 'col-xs-12 col-sm-5 col-md-5 nobreak')
					.append(ui.$$.label().text('Stadt *'))
					.append(cityInput.Input())
					.appendTo(fg);

				const stateDiv = ui.$$.div().addClass(agsDisplay === 'show' ? 'col-xs-12' : 'col-xs-12 col-sm-3 col-md-4 nobreak')
					.append(ui.$$.label().text('Bundesland *'))
					.append(stateSelect.Input());

				if (agsDisplay !== "show") {
					fg.append(stateDiv);
					if (agsDisplay === "hidden") {
						fg.append(agsInput.Input());
					}
				} else {
					fg = ui.$$.div().addClass('form-group clearfix').appendTo(target);
					fg.append(stateDiv);

					const agsDiv = ui.$$.div().addClass('col-xs-4')
						.append(ui.$$.label().text('Gemeindeschlüssel'))
						.append(agsInput.Input())
						.appendTo(fg);
				}

				// Add hidden fields with real data when using disabled form fields
				if (disabled)
				{
					fg.append(streetHidden.Input(), []);
					add(streetHidden, []);

					fg.append(housenumberHidden.Input(), []);
					add(housenumberHidden, []);

					fg.append(postalHidden.Input(), []);
					add(postalHidden, []);

					fg.append(cityHidden.Input());
					add(cityHidden, []);
				}
				fg.append(stateHidden.Input());
				fg.append(countryHidden.Input());

				const autocompleteOptions = {
					delay: 200,
					minLength: 3,
					source: (request, response) => {
						app.getObjectManager().resolveAddress(request.term, (answer) => {
							const results = [];
							for (const row of answer.data) {
								results.push({
									data: row,
									// value: row.PostalCode,
									label: `${row.PostalCode} ${row.City}, ${SPA.types.Address.State[row.State]}`
								});
							}
							response(results);
						});
					},
					select: (event, ui) => {
						postalcodeInput.value(ui.item.data.PostalCode);
						cityInput.value(ui.item.data.City);
						stateSelect.value(ui.item.data.State);
						agsInput.value(ui.item.data.AGS);
						if (disabled) {
							postalHidden.value(ui.item.data.PostalCode);
							cityHidden.value(ui.item.data.City);
						}
						stateHidden.value(ui.item.data.State);
						countryHidden.value('DE');
						// Trigger change event for geocoding
						postalcodeInput.Root().trigger('change');
						// Trigger for ags change
						$('html').trigger('agschange', [ui.item.data.AGS]);

						return false;
					}
				};
				postalcodeInput.Input().autocomplete(autocompleteOptions);
				cityInput.Input().autocomplete(autocompleteOptions);

				return list;
			}

			export function PostalAddressList( parameterBase: string ): ui.Form.BasicInputField[]
			{
				const list = new Array();

				if ( parameterBase.length > 0 && !parameterBase.endsWith( '.' ) )
				{
					parameterBase += '.';
				}

				list.push(
					new ui.Form.TextInput(
						'',
						{
							name: parameterBase + 'street',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Street' )
						}
					)
				);

				list.push(
					new ui.Form.TextInput(
						'',
						{
							name: parameterBase + 'housenumber',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' )
						}
					)
				);

				list.push(
					new ui.Form.TextInput(
						'',
						{
							name: parameterBase + 'postalcode',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' )
						}
					)
				);

				list.push(
					new ui.Form.TextInput(
						'',
						{
							name: parameterBase + 'city',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.City' )
						}
					)
				);

				list.push(
					new ui.Form.TextInput(
						'',
						{
							name: parameterBase + 'state',
							required: false,
							placeholder: app.getMessage( 'Address.LABEL.LONG.State' )
						}
					)
				);

				// list.push(
				// 	new ui.Form.TextInput(
				// 		'',
				// 		{
				// 			name: parameterBase + 'country',
				// 			required: false,
				// 			placeholder: app.getMessage( 'Address.LABEL.LONG.Country' )
				// 		}
				// 	)
				// );

				return list;
			}

			export function SimpleStyledPostalAddressList( form: ui.Form.Form, target: ui.base.BaseHTMLElement|JQuery, inputs: ui.Form.BasicInputField[] ): void
			{
				if ( target instanceof ui.base.BaseHTMLElement )
				{
					target = target.Root();
				}

				const add = ( input: ui.Form.BasicInputField, size: string[] ): void =>
				{
					input.addClass( size.join( ' ' ) );

					form.Input( input );
				};

				let fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' ) + '*' ).addClass( 'control-label col-sm-12 col-md-2' )
				).appendTo( target );
				add( inputs[ 0 ].rebuild( fg ), [ 'col-sm-12', 'col-md-7' ] );
				add( inputs[ 1 ].rebuild( fg ), [ 'col-sm-12', 'col-md-3' ] );

				fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.PC_City' ) + '*' ).addClass( 'control-label col-sm-12 col-md-2' )
				).appendTo( target );
				add( inputs[ 2 ].rebuild( fg ), [ 'col-sm-12', 'col-md-3' ] );
				add( inputs[ 3 ].rebuild( fg ), [ 'col-sm-12', 'col-md-7' ] );

				fg = ui.$$.div().addClass( 'form-group clearfix' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.State_Country' ) ).addClass( 'control-label col-sm-12 col-md-2' )
				).appendTo( target );

				add( inputs[ 4 ].rebuild( fg ), [ 'col-sm-12', 'col-md-5' ] );
				add( inputs[ 5 ].rebuild( fg ), [ 'col-sm-12', 'col-md-5' ] );
			}

		}
	}
}
